import ContactUsPage from '../pages/ContactUs';
import { ROUTES } from './routes.config';

export const ContactUsRoutes = {
    path: ROUTES.CONTACT_US,
    element: <ContactUsPage />,
};
